module.exports = __webpack_public_path__ + "static/media/christian.4ae319a4.jpg";